"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var react_1 = __importDefault(require("react"));

var SvgTimesOutline = function SvgTimesOutline(props) {
  return react_1.default.createElement("svg", __assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24'
  }, props), react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    id: 'times-outline_svg__a',
    d: 'M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 5.522-4.477 10-10 10S2 17.522 2 12zm2 0a8 8 0 1 0 16 0 8 8 0 0 0-16 0zm4.757-4.657L12 10.586l3.243-3.243c.463-.48.934-.48 1.414 0 .48.48.48.951 0 1.414L13.414 12l3.243 3.243c.471.471.471.942 0 1.414-.472.471-.943.471-1.414 0L12 13.414l-3.243 3.243c-.46.482-.932.482-1.414 0-.482-.482-.482-.954 0-1.414L10.586 12 7.343 8.757c-.472-.47-.472-.942 0-1.414s.944-.472 1.414 0z'
  })), react_1.default.createElement("use", {
    xlinkHref: '#times-outline_svg__a'
  }));
};

exports.default = SvgTimesOutline;